<template>
  <button class="flex items-center gap-1 cursor-pointer border-none bg-transparent p-0" @click="navigate">
    <feather-icon icon="ArrowLeftIcon" svgClasses="h-4 w-4" />
    {{ label || $t("buttons.back") }}
  </button>
</template>

<script>
export default {
  name: "BackLink",

  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },

  methods: {
    navigate() {
      if (this.to) {
        this.$router.push(this.to)
      } else {
        this.$router.back()
      }
    },
  },
}
</script>
